// extracted by mini-css-extract-plugin
export default {"wrapper":"jvRTF","icon":"oeXKi","content":"Q1sdS","link":"r9z2R"};